import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface LearnIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const LearnIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: LearnIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M12 3.5L3 8L12 12.5L21 8L12 3.5Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 10V13.6667C6 14.4741 6.48548 15.2023 7.23077 15.5128L11.2308 17.1795C11.7231 17.3846 12.2769 17.3846 12.7692 17.1795L16.7692 15.5128C17.5145 15.2023 18 14.4741 18 13.6667V10"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M12 8L9 10V18"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default LearnIcon
